module.exports = __webpack_public_path__ + "static/img/icon-9.b0bb60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/icon-9.png
// module id = ouln
// module chunks = 1